/**
 * Auth-protected layout wrapper for routes
 * @param roles - Array of allowed role IDs (default: ['admin'])
 * @param children - Route component to protect
 * @example
 * <ProtectedLayout roles={['admin', 'editor']}>
 *   <Dashboard />
 * </ProtectedLayout>
 */
import { ReactNode } from 'react';
import Layout from './Layout';
import ProtectedRoute from './ProtectedRoute';

/**
 * ProtectedLayout component props
 * @typedef {Object} ProtectedLayoutProps
 * @property {ReactNode} children - Route component to protect
 * @property {string[]} [roles=['admin']] - Array of allowed role IDs
 */
const ProtectedLayout = ({ children, roles }: { children: ReactNode, roles?: string[] }) => (
  <Layout>
    <ProtectedRoute roles={roles}>
      {children}
    </ProtectedRoute>
  </Layout>
);

export default ProtectedLayout;
